import React from 'react';

export function Btn({ variant = 'primary', size = '', className = '', testid, children, ...rest }) {
  const v = variant === 'primary' ? 'btn-primary' : variant === 'accent' ? 'btn-accent' : variant === 'outline' ? 'btn-outline' : variant === 'ghost' ? 'btn-ghost' : variant === 'danger' ? 'btn-danger' : '';
  const s = size === 'sm' ? 'btn-sm' : size === 'lg' ? 'btn-lg' : '';
  return <button data-testid={testid} className={`btn ${v} ${s} ${className}`} {...rest}>{children}</button>;
}

export function Input({ className = '', testid, ...rest }) {
  return <input data-testid={testid} className={`ios-input ${className}`} {...rest} />;
}
export function Textarea({ className = '', testid, ...rest }) {
  return <textarea data-testid={testid} className={`ios-textarea ${className}`} {...rest} />;
}
export function Select({ className = '', testid, children, value, onChange, ...rest }) {
  return <select data-testid={testid} value={value} onChange={onChange} className={`ios-select ${className}`} {...rest}>{children}</select>;
}
export function Switch({ checked, onChange, testid }) {
  return (
    <label className="ios-switch">
      <input type="checkbox" checked={!!checked} onChange={e => onChange(e.target.checked)} data-testid={testid} />
      <span className="track" />
      <span className="thumb" />
    </label>
  );
}
export function Field({ label, children, hint, className = '' }) {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && <label className="ios-label">{label}</label>}
      {children}
      {hint && <div className="text-xs text-[#8E8E93]">{hint}</div>}
    </div>
  );
}
export function Card({ children, className = '', compact = false, id, ...rest }) {
  return <div id={id} data-testid={rest['data-testid']} className={`${compact ? 'ios-card-compact' : 'ios-card'} ${className}`}>{children}</div>;
}
export function SectionTitle({ title, action }) {
  return (
    <div className="section-title">
      <h2>{title}</h2>
      {action}
    </div>
  );
}
export function Chip({ children, tone = 'neutral', className = '', testid }) {
  return <span data-testid={testid} className={`chip chip-${tone} ${className}`}>{children}</span>;
}
